import classNames from 'classnames';
import { RichText, Container } from 'ui/components';
import styles from './ArticleText.module.scss';
export interface ArticleTextProps {
	content: string;
	className?: string;
}

export const ArticleText: React.FC<ArticleTextProps> = ({ className, content }) => (
	<Container width={'Standard'} className={classNames(styles.ArticleText, className)}>
		<div className="u-grid__cell u-grid__cell--width-100">
			<RichText className={classNames('RichText', className)} content={content} />
		</div>
	</Container>
);
